module.exports = __webpack_public_path__ + "static/media/dBanner3.ee3097d2.png";